import { type SEOHandle } from '@nasa-gcn/remix-seo'
import { Outlet } from 'react-router'

export const handle: SEOHandle = {
	getSitemapEntries: () => null,
}

export default function IndustriesLayout() {
	return <Outlet />
}
